/**
 * @generated SignedSource<<44d5db7d434c33c50f211ae8b358a64e>>
 * @relayHash f9b10ce854bd3b612917f0d940680b5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTeamAdminControlsMode = "ALL_TEAMS" | "MEMBER_MANAGED_TEAMS" | "NO_TEAMS" | "VERIFIED_TEAMS" | "%future added value";
export type useConfluenceSiteTeamConfigurationsMutation$variables = {
  input: ConfluenceTeamAdminControlsMode;
};
export type useConfluenceSiteTeamConfigurationsMutation$data = {
  readonly confluence: {
    readonly updateTeamAdminControlsSettings: {
      readonly __typename: "ConfluenceUpdateTeamAdminControlsSettingsPayload";
      readonly errors: ReadonlyArray<{
        readonly __typename: "MutationError";
        readonly extensions: {
          readonly __typename: string;
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useConfluenceSiteTeamConfigurationsMutation = {
  response: useConfluenceSiteTeamConfigurationsMutation$data;
  variables: useConfluenceSiteTeamConfigurationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConfluenceSiteTeamConfigurationsMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
            "kind": "LinkedField",
            "name": "updateTeamAdminControlsSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfluenceSiteTeamConfigurationsMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
            "kind": "LinkedField",
            "name": "updateTeamAdminControlsSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f9b10ce854bd3b612917f0d940680b5b",
    "id": "f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff",
    "metadata": {},
    "name": "useConfluenceSiteTeamConfigurationsMutation",
    "operationKind": "mutation",
    "text": "mutation useConfluenceSiteTeamConfigurationsMutation($input:ConfluenceTeamAdminControlsMode!){confluence{updateTeamAdminControlsSettings(input:$input){success,errors{message,extensions{statusCode,errorType,__typename,...on BulkMutationErrorExtension{id}},__typename},__typename}}}"
  }
};
})();

(node as any).hash = "cb12cbeaf9954a0e8247aceccec6df18";

export default node;
